/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiKeycloakGetMemberRegistrationSequenceGet$Json$Params {
  Authorization?: string;
}

export function apiKeycloakGetMemberRegistrationSequenceGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetMemberRegistrationSequenceGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetMemberRegistrationSequenceGet$Json.PATH, 'get');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiKeycloakGetMemberRegistrationSequenceGet$Json.PATH = '/api/keycloak/GetMemberRegistrationSequence';
